import { useTranslation } from "react-i18next";

const GeneralPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-5">
        <h2 className="font-bold text-4xl">{t("policy.general.title")}</h2>
      </div>
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-5">
          <p className="font-bold text-xl">
            {t("policy.general.generalIntroduction")}
          </p>
          <ul className="list-disc pl-5">
            {/* <li>
              {t("policy.general.companyName")}:{" "}
              <span className="font-bold uppercase">
                {t("policy.general.companyNameValue")}
              </span>
            </li>
            <li>
              {t("policy.general.legalRepresentative")}:{" "}
              <span className="font-bold">
                {t("policy.general.legalRepresentativeValue")}
              </span>
            </li>
            <li>
              {t("policy.general.address")}: {t("policy.general.addressValue")}
            </li>
            <li>
              {t("policy.general.phone")}: {t("policy.general.phoneValue")}
            </li>
            <li>
              {t("policy.general.email")}: {t("policy.general.emailValue")}
            </li> */}
            {/* <li>
              {t("policy.general.businessRegistrationNumber")}:{" "}
              {t("policy.general.businessRegistrationNumberValue")}
            </li>
            <li>
              {t("policy.general.issueDate")}:{" "}
              {t("policy.general.issueDateValue")}
            </li> */}
            {/* <br /> */}
            <br />
            <li>
              {t("policy.general.companyName")}:{" "}
              <span className="font-bold uppercase">Traversia LLC</span>
            </li>
            <li>
              {t("policy.general.address")}: 1117 W Pioneer Parkway, STE 110,
              Arlington, TX 76013
            </li>
            <li>{t("policy.general.email")}: ……</li>
            <li>{t("policy.general.phone")}: 773-233-9874</li>
          </ul>
          <h2 className="font-bold text-xl">
            {t("policy.general.limitedConditionsTitle")}
          </h2>
          <p>{t("policy.general.limitedConditionsContent")}</p>
          <p>
            These Terms and referenced documents represent the entire agreement
            between you and TRAVERSIA, overriding prior discussions or
            arrangements.
          </p>
          <p>
            If any term is found unlawful or unenforceable, it will be modified
            or removed without affecting the rest of the agreement.
          </p>
          <p>
            TRAVERSIA may subcontract or assign its obligations. Events beyond
            our control ("force majeure") excuse performance.
          </p>
          <p>
            No third party may enforce these Terms, except lawful successors or
            assignees.
          </p>
          <p>
            Disputes will be governed by Federal Trade Commission regulations
            and handled exclusively in the state or federal courts of Maryland.
          </p>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.general.serviceStandardsTitle")}
          </h2>
          <p>{t("policy.general.serviceStandardsContent")}</p>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.general.obligationsTitle")}
          </h2>
          <p>{t("policy.general.obligationsContent1")}</p>
          <p>{t("policy.general.obligationsContent2")}</p>
          <p>{t("policy.general.feedbackWelcome")}</p>
          {/* <ul className="list-disc pl-5">
            <li>
              {t("policy.general.companyName")}:{" "}
              <span className="font-bold uppercase">
                {t("policy.general.companyNameValue")}
              </span>
            </li>
            <li>
              {t("policy.general.legalRepresentative")}:{" "}
              <span className="font-bold">
                {t("policy.general.legalRepresentativeValue")}
              </span>
            </li>
            <li>
              {t("policy.general.address")}: {t("policy.general.addressValue")}
            </li>
            <li>
              {t("policy.general.phone")}: {t("policy.general.phoneValue")}
            </li>
            <li>
              {t("policy.general.email")}: {t("policy.general.emailValue")}
            </li>
            <li>
              {t("policy.general.businessRegistrationNumber")}:{" "}
              {t("policy.general.businessRegistrationNumberValue")}
            </li>
            <li>
              {t("policy.general.issueDate")}:{" "}
              {t("policy.general.issueDateValue")}
            </li>
          </ul> */}
          <p>{t("policy.general.issuedBy")}</p>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">Parties and Scope</h2>
          <p>
            These Terms and Conditions ("Terms") outline the agreement between
            you, the customer ("you"), and TRAVERSIA LLC ("TRAVERSIA"),
            including all operating units and services.
          </p>
          <p>
            If you qualify as a "Consumer" under applicable laws, additional
            rights may apply. Businesses confirm their authority to act on
            behalf of their entity when purchasing services.
          </p>
          <p>
            These Terms, along with TRAVERSIA’s website provisions and Privacy
            Policy, form the entire agreement governing services, and no other
            terms apply unless explicitly accepted in writing. Updates to the
            Terms may occur without notice, but the version active at the time
            of your order will apply
          </p>
          <p>
            TRAVERSIA provides assistance for travel documentation, including
            visas, passports, document certification, and legalization. We
            ensure that forms are completed and submitted to authorities, but
            final decisions rest with issuing bodies. As a facilitator,
            TRAVERSIA is not responsible for those decisions or for services
            provided by third parties.
          </p>
          <p>
            Customers are responsible for reviewing and correcting errors before
            submitting orders. Once processing begins, the acknowledgment and
            acceptance email constitutes contract acceptance.
          </p>
          <p>
            Customers must verify that all returned documents meet their travel
            or certification needs, including validity, required stamps, and
            accuracy of personal details. Non-refundable bookings should be made
            only after all documents are secured.
          </p>
          <p>
            TRAVERSIA cannot guarantee approvals or processing timelines, as
            these are subject to the discretion of issuing authorities.
            Applications may be rejected without explanation, and additional
            documents may be requested. TRAVERSIA is not liable for delays,
            rejections, or expenses arising from consulates, embassies, or
            submission errors. While we base our information on official
            sources, we do not guarantee complete accuracy.
          </p>
          <p>
            The English version of these Terms governs the agreement.
            Translations are provided for convenience only. In case of
            inconsistencies, the English version shall prevail.
          </p>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">Procedure</h2>
          <p>
            TRAVERSIA is committed to providing accurate and timely support for
            obtaining visas, certified documents, and other travel
            documentation. Requirements may vary based on factors such as
            nationality, residence, age, profession, travel history, religion,
            and the type of document requested.
          </p>
          <p>
            Visa, passport, and document requirements are subject to change by
            sovereign nations at any time without prior notice. While we strive
            to provide reliable information, TRAVERSIA does not guarantee that
            all information is current or exhaustive.
          </p>
          <p>
            We act solely as a facilitator and do not assume responsibility for
            the accuracy of official information or final outcomes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default GeneralPolicy;
